module.exports = __webpack_public_path__ + "static/Phone Validation Product Brief-94c9a8e2f5442dbafdca4326b81b95ac.pdf";